import { render, staticRenderFns } from "./OrderSelectCustomer.vue?vue&type=template&id=462178b6&scoped=true&"
import script from "./OrderSelectCustomer.vue?vue&type=script&lang=js&"
export * from "./OrderSelectCustomer.vue?vue&type=script&lang=js&"
import style0 from "./OrderSelectCustomer.vue?vue&type=style&index=0&id=462178b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462178b6",
  null
  
)

export default component.exports